import React from "react";
import { Lock } from "lucide-react";

/**
 * Wraps an action panel and disables it if the current role lacks authority.
 */
export default function AuthorityGate({ allowed, currentRole, action, children }) {
    if (allowed) return children;
    return (
        <div
            className="relative panel-sunken p-5 md:p-6"
            data-testid={`authority-gate-${action}`}
        >
            <div className="flex items-center gap-2 mb-2">
                <Lock size={14} strokeWidth={1.5} className="text-oxblood" />
                <span className="label-eyebrow text-oxblood">Authority required</span>
            </div>
            <p className="text-sm text-ink-secondary">
                The current role <span className="font-mono">{currentRole}</span> does not have
                authority to perform this action. Switch role to proceed.
            </p>
            <div className="opacity-50 pointer-events-none mt-4">{children}</div>
        </div>
    );
}
